import { forwardRef } from 'react';

import { IconProps } from '.';

export const QrCodeIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path d="M7.12 7.12V5.62H5.62V7.12H7.12Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9.75H3.75C3.55189 9.74741 3.36263 9.66756 3.22253 9.52747C3.08244 9.38737 3.00259 9.19811 3 9V3.75C3 3.55109 3.07902 3.36032 3.21967 3.21967C3.36032 3.07902 3.55109 3 3.75 3H9C9.19891 3 9.38968 3.07902 9.53033 3.21967C9.67098 3.36032 9.75 3.55109 9.75 3.75V9C9.74741 9.19811 9.66756 9.38737 9.52747 9.52747C9.38737 9.66756 9.19811 9.74741 9 9.75ZM8.25 8.25V4.5H4.5V8.25H8.25Z"
        fill="currentColor"
      />
      <path d="M15.38 7.12V5.62H13.88V7.12H15.38Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 9.75H12C11.8019 9.74741 11.6126 9.66756 11.4725 9.52747C11.3324 9.38737 11.2526 9.19811 11.25 9V3.75C11.25 3.55109 11.329 3.36032 11.4697 3.21967C11.6103 3.07902 11.8011 3 12 3H17.25C17.4489 3 17.6397 3.07902 17.7803 3.21967C17.921 3.36032 18 3.55109 18 3.75V9C17.9974 9.19811 17.9176 9.38737 17.7775 9.52747C17.6374 9.66756 17.4481 9.74741 17.25 9.75ZM16.5 8.25V4.5H12.75V8.25H16.5Z"
        fill="currentColor"
      />
      <path d="M7.12 13.87V15.37H5.62V13.87H7.12Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 18H9C9.19811 17.9974 9.38737 17.9176 9.52747 17.7775C9.66756 17.6374 9.74741 17.4481 9.75 17.25V12C9.75 11.8011 9.67098 11.6103 9.53033 11.4697C9.38968 11.329 9.19891 11.25 9 11.25H3.75C3.55109 11.25 3.36032 11.329 3.21967 11.4697C3.07902 11.6103 3 11.8011 3 12V17.25C3.00259 17.4481 3.08244 17.6374 3.22253 17.7775C3.36263 17.9176 3.55189 17.9974 3.75 18ZM8.25 12.75V16.5H4.5V12.75H8.25Z"
        fill="currentColor"
      />
      <path d="M15.38 13.87V15.37H13.88V13.87H15.38Z" fill="currentColor" />
      <path
        d="M12.75 12.75V13.88H11.25V12C11.25 11.8011 11.329 11.6103 11.4697 11.4697C11.6103 11.329 11.8011 11.25 12 11.25H13.87V12.75H12.75Z"
        fill="currentColor"
      />
      <path d="M18 12V13.88H16.5V12.75H15.37V11.25H17.25C17.4489 11.25 17.6397 11.329 17.7803 11.4697C17.921 11.6103 18 11.8011 18 12Z" fill="currentColor" />
      <path
        d="M17.25 18H15.37V16.5H16.5V15.38H18V17.25C17.9974 17.4481 17.9176 17.6374 17.7775 17.7775C17.6374 17.9176 17.4481 17.9974 17.25 18Z"
        fill="currentColor"
      />
      <path
        d="M13.87 18H12C11.8019 17.9974 11.6126 17.9176 11.4725 17.7775C11.3324 17.6374 11.2526 17.4481 11.25 17.25V15.38H12.75V16.5H13.87V18Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default QrCodeIcon;
